import { render, staticRenderFns } from "./template.vue?vue&type=template&id=2cf912ad&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=2cf912ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf912ad",
  null
  
)

export default component.exports